import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import {
	Combobox,
	ComboboxContent,
	ComboboxEmpty,
	ComboboxInput,
	ComboboxItem,
	ComboboxList,
} from '../../../../web/components-v2/Combobox';

interface IProps {
	ariaLabel: string;
	emptyText: string;
	onChange: (value: string | null) => void;
	onSearchChange: (search: string) => void;
	options: string[];
	placeholder: string;
	search: string;
	styles?: StyleDeclarationValue[];
	value: string | null;
}

export const SearchFilter: React.FC<IProps> = ({
	ariaLabel,
	emptyText,
	onChange,
	onSearchChange,
	options,
	placeholder,
	search,
	styles = [],
	value,
}) => {
	return (
		<div className={css(...styles)}>
			<Combobox
				items={options}
				value={value}
				inputValue={search}
				onInputValueChange={onSearchChange}
				filter={null}
				onValueChange={(next: unknown) => onChange(typeof next === 'string' && next ? next : null)}
			>
				<ComboboxInput aria-label={ariaLabel} placeholder={placeholder} showClear />
				<ComboboxContent>
					<ComboboxEmpty>{emptyText}</ComboboxEmpty>
					<ComboboxList>
						{(option: string) => (
							<ComboboxItem key={option} value={option}>
								{option}
							</ComboboxItem>
						)}
					</ComboboxList>
				</ComboboxContent>
			</Combobox>
		</div>
	);
};

/** Keeps the typed search in step with the selection, so clearing or picking a value rewrites the input. */
export function useSyncedSearch(value: string | null) {
	const [search, setSearch] = useState(value ?? '');
	const [synced, setSynced] = useState(value);
	if (value !== synced) {
		setSynced(value);
		setSearch(value ?? '');
	}
	return [search, setSearch] as const;
}
